import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { ProjectsPage } from '@/pages/projects';
import { SORT_BY_DIRECTION, SORT_BY_VALUES } from '@/utils/sortTypes';

export const Route = createFileRoute('/_authenticated/_sidebar-layout/projects/')({
  validateSearch: zodValidator(
    z.object({
      view: fallback(z.enum(['grid', 'list', 'map']), 'list'),
      search: fallback(z.string().optional(), ''),
      filters: z.record(z.unknown()).optional(),
      sort: fallback(
        z
          .object({
            by: z.enum(SORT_BY_VALUES),
            order: z.enum(SORT_BY_DIRECTION),
          })
          .optional(),
        undefined
      ),
    })
  ),
  component: ProjectsPage,
});
